export function preferenceIdentity(fragrance) {
  return fragrance?.catalog_id ? `catalog:${fragrance.catalog_id}` : `personal:${fragrance?.id}`
}

export function rediscoverCandidates(collection, logs, favorites, { pool = 'favorites', occasion = '', season = '', excluded = [], limit = 5 } = {}) {
  const seen = new Set(excluded)
  const tags=value=>Array.isArray(value)?value.filter(item=>typeof item==='string'):[]
  return collection.filter(row => {
    const key = preferenceIdentity(row)
    if (seen.has(key) || row.given_away || row.finished || row.finished_at || row.deleted_at || row._optimistic) return false
    if (pool === 'favorites' && !favorites.has(key)) return false
    seen.add(key); return true
  }).map(row => {
    const ids = new Set(collection.filter(other=>preferenceIdentity(other)===preferenceIdentity(row)).flatMap(other=>[other.id,...(other.sizes || []).map(size=>size.id)]))
    const dates = logs.filter(log => ids.has(log.fragrance_id)).map(log => Date.parse(log.worn_on || log.created_at)).filter(Number.isFinite)
    const last = dates.length ? Math.max(...dates) : null
    const context = occasion && tags(row.occasions).some(value => value.toLowerCase() === occasion.toLowerCase()) ? 1 : 0
    const weather = season && tags(row.seasons).some(value => value.toLowerCase() === season.toLowerCase()) ? 1 : 0
    const favorite = favorites.has(preferenceIdentity(row))
    return { fragrance: row, last, context, weather, reason: context ? `Listed for ${occasion.toLowerCase()}` : last !== null ? `Last logged ${new Date(last).toLocaleDateString()}` : favorite ? 'From your favorites' : 'From your collection' }
  }).sort((a,b) => b.context-a.context || b.weather-a.weather || (a.last ?? Infinity)-(b.last ?? Infinity) || String(a.fragrance.name || '').localeCompare(String(b.fragrance.name || ''))).slice(0,limit)
}

export function batchSelection(row, destination) {
  if (!row?.id || !['collection','wishlist'].includes(destination)) throw new Error('Choose a fragrance and destination.')
  return { id: row.id, destination, concentration: row.concentration_display || row.concentration || null }
}

export function settleBatch(pending, results) {
  if (!Array.isArray(results) || results.length !== pending.length || new Set(results.map(row => row.id)).size !== pending.length) throw new Error('Save confirmation is incomplete. Retry this selection safely.')
  const byId = new Map(results.map(row => [row.id,row]))
  if (pending.some(item => byId.get(item.id)?.destination !== item.destination)) throw new Error('Save confirmation does not match your selection.')
  if (results.some(row => !['saved','already_owned','failed'].includes(row.status))) throw new Error('Save confirmation contains an unknown result. Retry this selection safely.')
  return {
    remaining: pending.filter(item => !['saved','already_owned'].includes(byId.get(item.id)?.status)),
    collection: results.filter(row => row.status === 'saved' && row.destination === 'collection').length,
    wishlist: results.filter(row => row.status === 'saved' && row.destination === 'wishlist').length,
    bottles: results.flatMap(row => row.bottle ? [row.bottle] : []),
    errors: results.filter(row => row.status === 'failed').map(row => row.message),
  }
}

export function checkinTimeline(log) {
  const levels = ['gone','skin scent','projecting as expected','projecting above average','strong']
  return (log.performance_checkins || []).filter(point => levels.includes(point.value) && Number.isFinite(Date.parse(point.at)))
    .map(point => ({ ...point, level: levels.indexOf(point.value)+1 })).sort((a,b) => Date.parse(a.at)-Date.parse(b.at))
}

export const EXPLORE_BATCH_LIMIT = 100
export function toggleBatchItem(items, item) {
  if(items.some(value=>value.id===item.id&&value.destination===item.destination))return {items:items.filter(value=>value.id!==item.id),error:''}
  if(!items.some(value=>value.id===item.id)&&items.length>=EXPLORE_BATCH_LIMIT)return {items,error:'Choose up to 100 fragrances per save. Save or remove some before adding another.'}
  return {items:[...items.filter(value=>value.id!==item.id),item],error:''}
}
